module.exports = __webpack_public_path__ + "img/1.0be0bcda.jpg";